// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.file-select-container {
  width: 100%;
  height: var(--input-element-height);
  cursor: pointer;
  display: flex;
  flex-direction: row;
  padding: 0;
  border-radius: calc(var(--input-element-height) / 2);
  gap: 0;
}

.file-select-container-readonly {
  cursor: default;
}

.file-select-hidden-input {
  display: none;
}

.file-select-input {
  flex-grow: 1;
  border-top-right-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
  border-right-width: 0 !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: calc(
    var(--input-element-height) - 2px
  ); /* -2px to compensate for border */
}

.file-select-button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  min-width: unset;

  & :hover {
    box-shadow: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/file-input/FileSelect.component.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mCAAmC;EACnC,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,oDAAoD;EACpD,MAAM;AACR;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,wCAAwC;EACxC,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB;;GAEC,EAAE,kCAAkC;AACvC;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;;EAEhB;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".file-select-container {\n  width: 100%;\n  height: var(--input-element-height);\n  cursor: pointer;\n  display: flex;\n  flex-direction: row;\n  padding: 0;\n  border-radius: calc(var(--input-element-height) / 2);\n  gap: 0;\n}\n\n.file-select-container-readonly {\n  cursor: default;\n}\n\n.file-select-hidden-input {\n  display: none;\n}\n\n.file-select-input {\n  flex-grow: 1;\n  border-top-right-radius: 0 !important;\n  border-bottom-right-radius: 0 !important;\n  border-right-width: 0 !important;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  line-height: calc(\n    var(--input-element-height) - 2px\n  ); /* -2px to compensate for border */\n}\n\n.file-select-button {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  min-width: unset;\n\n  & :hover {\n    box-shadow: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
